const e=(e,t)=>t=>{Object.keys(e).forEach(n=>{t.css(n)||t.css(n,e[n])})};export{e as injectCssPropertiesIntoRootElementMutatorFactory};
//# sourceMappingURL=inject-css-properties-into-root-element.js.map